const languages = [
    {
        key: 'en',
        name: 'English',
        shortName: 'ENG'
    },
    {
        key: 'vi',
        name: 'Tiếng Việt',
        shortName: 'VN'
    }
]

export default languages;
